import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {Prediction} from '../../domain/prediction';

@Injectable()
export class PredictionService {

    readonly PREDICTION_URL = environment.backendUrl + '/brain-monitor/api/invoice-processing-infos';

    constructor(private http: HttpClient) {
    }

    getPredictions(pageIndex: number,
                   pageSize: number,
                   filters: any,
                   sort: string,
                   startDate: Date,
                   endDate: Date,
    ): Observable<any> {

        let httpParams = new HttpParams()
            .set('page', pageIndex.toString())
            .set('size', pageSize.toString());

        if (filters && Object.keys(filters).length > 0) {
            for (const key in filters) {
                httpParams = httpParams.set(key + '.' + filters[key].matchMode, filters[key].value);
            }
        }
        if (startDate) {
            httpParams = httpParams.set('lastModified.greaterThanOrEqual', startDate.toISOString());
        }
        if (endDate) {
            httpParams = httpParams.set('lastModified.lessThanOrEqual', endDate.toISOString());
        }

        httpParams = httpParams.set('sort', sort);

        return this.http.get<any>(this.PREDICTION_URL, {params: httpParams});
    }

    savePrediction(prediction: Prediction): Observable<any> {
        return this.http.post<any>(this.PREDICTION_URL, prediction);
    }

    deletePrediction(prediction: Prediction): Observable<any> {
        return this.http.delete<any>(this.PREDICTION_URL.concat('/').concat(prediction.id.toString()));
    }

    updatePrediction(prediction: Prediction): Observable<any> {
        return this.http.put<any>(this.PREDICTION_URL, prediction);
    }

    getPerformance(filters: any,
                   startDate: Date,
                   endDate: Date): Observable<any> {
        const httpParams = this.buildParams(filters, startDate, endDate);

        return this.http.get<any>(this.PREDICTION_URL.concat('/performance'), {params: httpParams});
    }

    countUniqueInvoices(filters: any,
                        startDate: Date,
                        endDate: Date): Observable<any> {
        const httpParams = this.buildParams(filters, startDate, endDate);

        return this.http.get<any>(this.PREDICTION_URL.concat('/count/unique'), {params: httpParams});
    }

    exportPredictions(invoiceIds?: number[]): Observable<any> {

        let params = new HttpParams();
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/csv');

        if (invoiceIds) {
            params = params.set('ids', invoiceIds.toString());
            return this.http.get(this.PREDICTION_URL.concat('/download/csv'), {
                params,
                headers,
                responseType: 'blob' as 'blob'
            });
        }
    }

    private buildParams(filters: any, startDate: Date, endDate: Date) {
        let httpParams = new HttpParams();

        if (filters && Object.keys(filters).length > 0) {
            for (const key in filters) {
                httpParams = httpParams.set(key + '.' + filters[key].matchMode, filters[key].value);
            }
        }
        if (startDate) {
            httpParams = httpParams.set('lastModified.greaterThanOrEqual', startDate.toISOString());
        }
        if (endDate) {
            httpParams = httpParams.set('lastModified.lessThanOrEqual', endDate.toISOString());
        }
        return httpParams;
    }
}
